// extracted by mini-css-extract-plugin
export default {"generalMap":"Grouping_Map_generalMap__QndCf","generalMarker":"Grouping_Map_generalMarker__iggu9"};